import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { AuthService } from '@hub/services/AuthService';

@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  constructor(private auth: AuthService) {
    super();
  }

  parse(url: string): UrlTree {
    if (this.auth.isLogged) {
      return super.parse(url.toLowerCase());
    } else {
      return super.parse(url);
    }
  }
}
